var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "btn btn-default favourite",
      class: { disabled: _vm.disabled },
      attrs: { title: _vm.linkTitle },
      on: { click: _vm.submitFavourite },
    },
    [_c("i", { class: _vm.iconClass })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }